export function generateMeetingList(getRoutinesAvailable: any[]) {
  return (getRoutinesAvailable || []).map(routineAvailable => ({
    label: routineAvailable?.name,
    value: routineAvailable?.slug,
    id: routineAvailable?.id,
  }));
}
